import { type RouteObject } from 'react-router';
import Companies from 'Components/Companies';
import { AllIndustries } from '../Components/Industries/AllIndustries';
import CreateIndustry from '../Components/Industries/CreateIndustry/CreateIndustry';
import { Contracts } from 'Components/Contracts/Contracts';
import { NotFound } from '@consolidocs-ui/components';
import { EditIndustry } from '../Components/Industries/EditIndustry/EditIndustry';
import CreateContract from '../Components/Contracts/CreateContract/CreateContract';
import { EditContract } from '../Components/Contracts/EditContract/EditContract';
import GlobalSettings from '../Components/GlobalSettings';
import {
  CreateCompanyPage,
  EditCompanyPage,
} from '../Components/CreateOrEditCompany';

export const appRoutes: RouteObject[] = [
  {
    path: '/',
    element: <Companies />,
  },
  {
    path: '/companies/create',
    element: <CreateCompanyPage />,
  },
  {
    path: '/companies/edit/:companyId',
    element: <EditCompanyPage />,
  },
  {
    path: '/global-settings',
    element: <GlobalSettings />,
  },
  {
    path: '/industries',
    element: <AllIndustries />,
  },
  {
    path: '/industries/create',
    element: <CreateIndustry />,
  },
  {
    path: '/industries/edit/:industryId',
    element: <EditIndustry />,
  },
  {
    path: '/contracts',
    element: <Contracts />,
  },
  {
    path: '/contracts/create',
    element: <CreateContract />,
  },
  {
    path: '/contracts/edit/:contractId',
    element: <EditContract />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];
